export namespace Addresses {
  export interface IAddressVia {
    bairro: string;
    cep: string;
    complemento: string;
    ddd: string;
    gia: string;
    ibge: string;
    localidade: string;
    logradouro: string;
    numero: string;
    siafi: string;
    uf: string;
    pais: string;
  }

  export class AddressVia implements IAddressVia {
    bairro: string = "";
    cep: string = "";
    complemento: string = "";
    ddd: string = "";
    gia: string = "";
    ibge: string = "";
    localidade: string = "";
    logradouro: string = "";
    numero: string = "";
    siafi: string = "";
    uf: string = "";
    pais: string = "";
  }

  export interface IAddress {
    id: number;
    addressName: string;
    addressNumber: string;
    complement: string;
    district: string;
    city: string;
    uf: string;
    zipCode: string;
    country: string;
    latitude: number;
    longitude: number
    delivery: boolean;
  }

  export class Address implements IAddress {
    id: number = 0;
    addressName: string = "";
    addressNumber: string = "";
    complement: string = "";
    district: string = "";
    city: string = "";
    uf: string = "";
    zipCode: string = "";
    country: string = "";
    latitude: number = 0;
    longitude: number = 0;
    delivery: boolean = false;
  }
}
